import { addDays, format, getISODay, startOfDay, subDays } from "date-fns";

export function currentWeekPeriod(referenceDate = new Date()) {
  const date = startOfDay(referenceDate);
  const isoDay = getISODay(date);
  const daysSinceWed = (isoDay - 3 + 7) % 7;
  const periodStart = subDays(date, daysSinceWed);
  const periodEnd = addDays(periodStart, 6);

  return {
    from: format(periodStart, "yyyy-MM-dd"),
    to: format(periodEnd, "yyyy-MM-dd")
  };
}
